module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    class: !_vm.isMovil ? 'box-data-user' : 'box-data-movil',
    attrs: {
      "nav": "nav",
      "dense": "dense"
    }
  }, [(_vm.usuario.codigoSap) ? _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("account_box")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Codigo SAP")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.codigoSap
    }
  }, [_vm._v(_vm._s(_vm.usuario.codigoSap ? _vm.usuario.codigoSap.toUpperCase() : 'No asignado'))])], 1), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "small": "small",
      "color": "primary",
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": function($event) {
        return _vm.habilitarEdicionCodigoSAP()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1) : _c('v-sheet', {
    attrs: {
      "color": _vm.showDetailsDataSAP ? '' : 'secondary'
    }
  }, [(_vm.showDetailsDataSAP) ? _c('v-list', {
    staticClass: "elevation-4",
    attrs: {
      "two-line": "",
      "dense": "dense",
      "color": "background"
    }
  }, [_c('v-list-item', [_c('v-btn', {
    attrs: {
      "color": "error",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.limpiarDatosClienteSAP()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("Volver")], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.datosClienteSAP.nombreCliente)
    }
  }), _c('v-list-item-subtitle', {
    domProps: {
      "innerHTML": _vm._s(_vm.datosClienteSAP.direccion)
    }
  })], 1)], 1), _c('v-list-item', [_c('v-btn', {
    class: {
      'mt-4': _vm.isMovil
    },
    attrs: {
      "color": "success",
      "block": "block",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchAsignarCodigoSap()
      }
    }
  }, [_vm._v("Asignar codigo SAP")])], 1)], 1) : _c('div', {
    staticClass: "d-flex pa-4"
  }, [_c('v-text-field', {
    ref: "codigoClienteSAP",
    attrs: {
      "solo": "solo",
      "disabled": _vm.perfil === 'supervisor',
      "dense": "dense",
      "label": "Ingresa un codigo SAP para esta cuenta",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGetDatosSAP()
      }
    },
    model: {
      value: (_vm.codigoClienteSAP),
      callback: function($$v) {
        _vm.codigoClienteSAP = $$v
      },
      expression: "codigoClienteSAP"
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "color": "info",
            "disabled": _vm.perfil === 'supervisor',
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fetchGetDatosSAP()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("person_search")])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Obtener datos de SAP")])])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), (_vm.usuario.telefono) ? _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("call")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Telefono")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.telefono
    }
  }, [_vm._v(_vm._s(_vm.usuario.telefono ? _vm.usuario.telefono : 'No asignado'))])], 1), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "fab": "fab",
      "small": "small",
      "color": "primary",
      "disabled": _vm.perfil === 'supervisor'
    },
    on: {
      "click": _vm.habilitarEdicionTelefono
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1) : _c('v-sheet', {
    attrs: {
      "color": _vm.showTelefonoCliente ? '' : 'secondary'
    }
  }, [(_vm.showTelefonoCliente) ? _c('v-list', {
    staticClass: "elevation-4",
    attrs: {
      "two-line": "",
      "dense": "dense",
      "color": "background"
    }
  }, [_c('v-list-item', [_c('v-btn', {
    attrs: {
      "color": "error",
      "block": _vm.isMovil,
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.limpiarDatosTelefonoCliente()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _vm._v("Volver")], 1)], 1), _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', {
    domProps: {
      "innerHTML": _vm._s(_vm.datosClienteSAP.nombreCliente)
    }
  }), _c('v-list-item-subtitle', {
    domProps: {
      "innerHTML": _vm._s(_vm.datosClienteSAP.direccion)
    }
  })], 1)], 1), _c('v-list-item', [_c('v-btn', {
    class: {
      'mt-4': _vm.isMovil
    },
    attrs: {
      "color": "success",
      "block": "block",
      "small": !_vm.isMovil
    }
  }, [_vm._v("Asignar codigo SAP")])], 1)], 1) : _c('div', {
    staticClass: "d-flex pa-4"
  }, [_c('v-text-field', {
    ref: "numeroTelefonoCliente",
    attrs: {
      "solo": "solo",
      "disabled": _vm.perfil === 'supervisor',
      "dense": "dense",
      "label": "Ingresa un numero de telefono para enlazar este usuario",
      "hide-details": "",
      "clearable": "",
      "clear-icon": "close"
    },
    model: {
      value: (_vm.numeroTelefonoCliente),
      callback: function($$v) {
        _vm.numeroTelefonoCliente = $$v
      },
      expression: "numeroTelefonoCliente"
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "color": "info ",
            "disabled": _vm.perfil === 'supervisor',
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fetchSaveDatosCliente()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("check")])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Guardar cambios")])])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("apartment")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Entidad")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.entidad
    }
  }, [_vm._v(_vm._s(_vm.usuario.entidad ? _vm.usuario.entidad.toUpperCase() : 'No definido'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("alternate_email")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Usuario / Email")]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.usuario.usuario))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), (_vm.usuario.entidad === 'empresa') ? _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("badge")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Razon Social")]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.usuario.razonSocial))])], 1)], 1) : _vm._e(), (_vm.usuario.entidad === 'empresa') ? _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }) : _vm._e(), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("person")])], 1), _c('v-list-item-content', [(_vm.usuario.entidad === 'empresa') ? _c('v-list-item-title', [_vm._v("Nombre contacto")]) : _c('v-list-item-title', [_vm._v("Nombre")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.nombre
    }
  }, [_vm._v(_vm._s(_vm.usuario.nombre))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("portrait")])], 1), _c('v-list-item-content', [(_vm.usuario.entidad === 'empresa') ? _c('v-list-item-title', [_vm._v("Documento contacto")]) : _c('v-list-item-title', [_vm._v("Documento")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.documento
    }
  }, [_vm._v(_vm._s(_vm.usuario.documento ? _vm.usuario.documento : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("work")])], 1), _c('v-list-item-content', [(_vm.usuario.entidad === 'empresa') ? _c('v-list-item-title', [_vm._v("Cargo contacto")]) : _c('v-list-item-title', [_vm._v("Cargo")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.cargo
    }
  }, [_vm._v(_vm._s(_vm.usuario.cargo ? _vm.usuario.cargo : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), (_vm.usuario.entidad === 'empresa') ? _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("gavel")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("RUC")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.ruc
    }
  }, [_vm._v(_vm._s(_vm.usuario.ruc ? _vm.usuario.ruc : 'No asignado'))])], 1)], 1) : _vm._e(), (_vm.usuario.entidad === 'empresa') ? _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }) : _vm._e(), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("place")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Direccion")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.direccion
    }
  }, [_vm._v(_vm._s(_vm.usuario.direccion ? _vm.usuario.direccion : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("circle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Ubigeo")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.ubigeo
    }
  }, [_vm._v(_vm._s(_vm.usuario.ubigeo ? _vm.usuario.ubigeo : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("circle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Departamento")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.departamento
    }
  }, [_vm._v(_vm._s(_vm.usuario.departamento ? _vm.usuario.departamento : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("circle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Provincia")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.provincia
    }
  }, [_vm._v(_vm._s(_vm.usuario.provincia ? _vm.usuario.provincia : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("circle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Distrito")]), _c('v-list-item-subtitle', {
    class: {
      'error--text': !_vm.usuario.distrito
    }
  }, [_vm._v(_vm._s(_vm.usuario.distrito ? _vm.usuario.distrito : 'No asignado'))])], 1)], 1), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _c('v-list-item', {
    staticClass: "px-4"
  }, [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary",
      "size": 23
    }
  }, [_vm._v("folder_shared")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v("Acepta compartir sus datos personales")]), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.usuario.aceptaPoliticasDeprivacidad ? 'SI' : 'NO'))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-630610ce","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_card_informacion_usuario.vue
// module id = 504
// module chunks = 1